import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetDeptLists,
  trunkGetDeptDetail,
  trunkGetDeptUsers,
  trunkGetDeptInfo,
  trunkGetUserDetail,
  trunkUpdateUserDept,
  trunkUpdateExternalUserDept,
  trunkAddUserDept,
  trunkGetActiveInternalUserList,
  trunkGetActiveExternalUserList,
  trunkGetInternalUserList,
  trunkGetExternalUserList,
  trunkDownloadDeptFile,
  trunkUploadDeptFile,
  trunkUpdateDeptParent,
  trunkUpdateDeptManager,
  trunkDeleteDept,
  trunkDeleteUser,
  trunkAddDept,
  trunkUserPasswdUpdate,
  trunkUserPasswdInit,
  trunkChangeDeptName,
} from "../store/admin/adminDept";

const useAdminDeptStore = () => {
  const adminDeptStore = useRootState((state) => state.adminDeptStore);

  const dispatch = useAppDispatch();

  const boundGetDeptLists = useMemo(
    () => bindActionCreators(trunkGetDeptLists, dispatch),
    [dispatch]
  );
  const boundGetDeptDetail = useMemo(
    () => bindActionCreators(trunkGetDeptDetail, dispatch),
    [dispatch]
  );
  const boundGetDeptUsers = useMemo(
    () => bindActionCreators(trunkGetDeptUsers, dispatch),
    [dispatch]
  );
  const boundGetDeptInfo = useMemo(
    () => bindActionCreators(trunkGetDeptInfo, dispatch),
    [dispatch]
  );
  const boundGetUserDetail = useMemo(
    () => bindActionCreators(trunkGetUserDetail, dispatch),
    [dispatch]
  );
  const boundUpdateUserDept = useMemo(
    () => bindActionCreators(trunkUpdateUserDept, dispatch),
    [dispatch]
  );
  const boundUpdateExternalUserDept = useMemo(
    () => bindActionCreators(trunkUpdateExternalUserDept, dispatch),
    [dispatch]
  );
  const boundAddUserDept = useMemo(
    () => bindActionCreators(trunkAddUserDept, dispatch),
    [dispatch]
  );
  const boundGetActiveInternalUserList = useMemo(
    () => bindActionCreators(trunkGetActiveInternalUserList, dispatch),
    [dispatch]
  );
  const boundGetActiveExternalUserList = useMemo(
    () => bindActionCreators(trunkGetActiveExternalUserList, dispatch),
    [dispatch]
  );
  const boundGetInternalUserList = useMemo(
    () => bindActionCreators(trunkGetInternalUserList, dispatch),
    [dispatch]
  );
  const boundGetExternalUserList = useMemo(
    () => bindActionCreators(trunkGetExternalUserList, dispatch),
    [dispatch]
  );
  const boundDownloadDeptFile = useMemo(
    () => bindActionCreators(trunkDownloadDeptFile, dispatch),
    [dispatch]
  );
  const boundUploadDeptFile = useMemo(
    () => bindActionCreators(trunkUploadDeptFile, dispatch),
    [dispatch]
  );
  const boundUpdateDeptParent = useMemo(
    () => bindActionCreators(trunkUpdateDeptParent, dispatch),
    [dispatch]
  );
  const boundUpdateDeptManager = useMemo(
    () => bindActionCreators(trunkUpdateDeptManager, dispatch),
    [dispatch]
  );
  const boundDeleteDept = useMemo(
    () => bindActionCreators(trunkDeleteDept, dispatch),
    [dispatch]
  );
  const boundDeleteUser = useMemo(
    () => bindActionCreators(trunkDeleteUser, dispatch),
    [dispatch]
  );
  const boundAddDept = useMemo(
    () => bindActionCreators(trunkAddDept, dispatch),
    [dispatch]
  );
  const boundUserPasswdUpdate = useMemo(
    () => bindActionCreators(trunkUserPasswdUpdate, dispatch),
    [dispatch]
  );
  const boundUserPasswdInit = useMemo(
    () => bindActionCreators(trunkUserPasswdInit, dispatch),
    [dispatch]
  );
  const boundChangeDeptName = useMemo(
    () => bindActionCreators(trunkChangeDeptName, dispatch),
    [dispatch]
  );

  return {
    adminDeptStore,
    getDeptLists: boundGetDeptLists,
    getDeptDetail: boundGetDeptDetail,
    getDeptUsers: boundGetDeptUsers,
    getDeptInfo: boundGetDeptInfo,
    getUserDetail: boundGetUserDetail,
    updateUserDept: boundUpdateUserDept,
    updateExternalUserDept: boundUpdateExternalUserDept,
    addUserDept: boundAddUserDept,
    getActiveInternalUserList: boundGetActiveInternalUserList,
    getActiveExternalUserList: boundGetActiveExternalUserList,
    getInternalUserList: boundGetInternalUserList,
    getExternalUserList: boundGetExternalUserList,
    downloadDeptFile: boundDownloadDeptFile,
    uploadDeptFile: boundUploadDeptFile,
    updateDeptParent: boundUpdateDeptParent,
    updateDeptManager: boundUpdateDeptManager,
    deleteDept: boundDeleteDept,
    deleteUser: boundDeleteUser,
    addDept: boundAddDept,
    userPasswdUpdate: boundUserPasswdUpdate,
    userPasswdInit: boundUserPasswdInit,
    changeDeptName: boundChangeDeptName,
  };
};

export default useAdminDeptStore;
